import { createRoot } from 'react-dom/client'
import CollectionPageInit from './components/CollectionPageInit'

const container = document.getElementById('ss-react-init-collection')!
const root = createRoot(container)
root.render(
    <CollectionPageInit />
)
